import * as React from 'react';
import Carousel from 'react-native-reanimated-carousel';
import { useBannerListQuery } from 'src/common/hooks/useBannerListQuery';
import { Container } from 'src/components';
import CustomFastImage from 'src/components/bases/CustomFastImage';
import { device, pixelScaler } from 'src/themes/Metrics';

const ENTRIES1 = [
  {
    image: 'https://i.imgur.com/UYiroysl.jpg',
  },
  {
    image: 'https://i.imgur.com/UPrs1EWl.jpg',
  },
  {
    image: 'https://i.imgur.com/MABUbpDl.jpg',
  },
  {
    image: 'https://i.imgur.com/UPrs1EWl.jpg',
  },
];

export const BannerRunning = () => {
  const { data: bannerList, isFetched } = useBannerListQuery();
  const [snapIndex, setSnapIndex] = React.useState(0);

  console.log({ bannerList });

  const renderItem = React.useCallback(({ item }: any) => {
    return (
      <CustomFastImage
        source={{
          uri: item.image,
        }}
        width="100%"
        height="100%"
      />
    );
  }, []);

  return (
    <Container>
      <Carousel
        loop
        modeConfig={{
          parallaxScrollingScale: 0.9,
          parallaxScrollingOffset: 50,
        }}
        autoPlayInterval={3000}
        autoPlay
        data={bannerList}
        width={device.width}
        height={pixelScaler(210)}
        renderItem={renderItem}
        pagingEnabled
        onSnapToItem={setSnapIndex}
      />
      {/* <Row style={{ position: 'absolute', bottom: metrics.medium, left: 0 }}>
        {isFetched && (
          <Row width={device.width} style={{ alignItems: 'center', justifyContent: 'center' }}>
            {bannerList.map((image: any, index: number) => (
              <Container
                key={index.toString()}
                height={pixelScaler(8)}
                width={pixelScaler(8)}
                marginRight={metrics.small}
                borderRadius={10}
                backgroundColor={snapIndex === index ? AppColors.white : AppColors.gray}
              />
            ))}
          </Row>
        )}
      </Row> */}
    </Container>
  );
};
